// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1LZFj","requiredAsterisk":"Info_requiredAsterisk__1Axmg"};